import React, { useEffect, useState } from 'react';
// import moment from 'moment';
import { CloseCircleOutlined } from '@ant-design/icons';
import { useLocation } from 'react-router-dom';
import { Form } from 'antd';
import { useForm } from 'antd/es/form/Form';
import { parseJwt } from '../../../utils/session';
import PreviousButton from '../../EnrollmentPage/components/steps/InvestorProfileStep/PreviousButton';
import EvaluationProgress from './EvaluationProgress';
import EvaluationSurveyData from './EvaluationSurveyData';
import EvaluationQuestion from './EvaluationQuestion';
import ApiExecutiveEvaluation from '../api/api-executive-evaluation';

const EvaluationSurvey = () => {
  const query = new URLSearchParams(useLocation().search);
  const [evaluationForm] = useForm();
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  const [payload, setPayload] = useState({ customerInquiryId: parseJwt(query.get('token')).id });
  const [sentEvaluation, setSentEvaluation] = useState(false);
  const [statusEvaluation, setStatusEvaluation] = useState('');
  const [questions] = useState(EvaluationSurveyData.questions);

  const currentQuestion = questions[currentQuestionIndex];

  useEffect(async () => {
    const status = await ApiExecutiveEvaluation.getStatusExecutiveEvaluation({
      token: query.get('token'),
    });

    if (status.data.inquiryState === 'FINISHED') {
      setStatusEvaluation('FINISHED');
    }
  }, []);

  const goToPreviousQuestion = () => {
    setCurrentQuestionIndex(Math.max(currentQuestionIndex - 1, 0));
  };

  const goToNextQuestion = () => {
    setCurrentQuestionIndex(Math.min(currentQuestionIndex + 1, questions.length - 1));
  };

  const onAnswer = () => {
    goToNextQuestion();
  };

  const buildPayload = (currentCuestion, answer, value) => {
    setPayload((prevPayload) => ({
      ...prevPayload,
      [currentCuestion.field]: answer ? answer.value : value,
    }));
  };

  const sendEvaluation = (dataPayload) => {
    const {
      hasKnowledge,
      isAvailable,
      isSatisfied,
      isUtilInfo,
      sendComment,
      comment,
    } = dataPayload;
    const data = {
      hasKnowledge,
      isAvailable,
      isSatisfied,
      isUtilInfo,
      sendComment,
      comment,
      token: query.get('token'),
    };

    ApiExecutiveEvaluation.createExecutiveEvaluation(data)
      .then(() => {})
      .catch(() => {});
  };

  const finishedEvaluation = (finished) => {
    setSentEvaluation(finished);
  };

  return (
    <>
      {statusEvaluation === 'FINISHED' && (
        <Form form={evaluationForm} layout="vertical" hideRequiredMark preserve>
          <Form.Item style={{ textAlign: 'center' }}>
            <p>
              <b>Evaluación ya se encuentra respondida</b>
            </p>
            <CloseCircleOutlined
              style={{ fontSize: '150px', color: '#B22938', marginBottom: 20 }}
            />
            <p>¡Muchas gracias por ayudarnos a mejorar!</p>
          </Form.Item>
        </Form>
      )}

      {statusEvaluation !== 'FINISHED' && (
        <Form form={evaluationForm} layout="vertical" hideRequiredMark preserve>
          {!sentEvaluation && <EvaluationProgress currentQuestionIndex={currentQuestionIndex} />}

          {currentQuestion && (
            <EvaluationQuestion
              key={`answer-${currentQuestionIndex}`}
              question={currentQuestion}
              onAnswer={onAnswer}
              buildPayload={buildPayload}
              payload={payload}
              onFinish={() => sendEvaluation(payload)}
              finishedEvaluation={finishedEvaluation}
              sentEvaluation={sentEvaluation}
            />
          )}

          {!sentEvaluation && currentQuestion.order !== 1 && (
            <PreviousButton onClick={goToPreviousQuestion}>
              Volver a pregunta anterior
            </PreviousButton>
          )}
        </Form>
      )}
    </>
  );
};

export default EvaluationSurvey;
